import React, { useCallback, useRef, useState } from "react";
import { usePlayVideoInView } from "hooks/usePlayInView";
import { absoluteAssetUrl, getOptimizedImageUrl } from "util/assets";
import { useVideoCleanup } from "hooks/useDestroyVideoRef";
import { IHeroSection } from "../Hero/Hero.types";
import * as S from "./HeroVideoPlayInView.styles";

const SINGLE_SECTION = 1;

export const HeroVideoPlayInView = ({
  section,
  isInView,
  totalSectionsCount,
}: Readonly<{
  section: IHeroSection;
  isInView?: boolean;
  totalSectionsCount: number;
  onLoadedMetadata?: (event: React.SyntheticEvent<HTMLVideoElement>) => void;
  onVideoEnd?: () => void;
}>) => {
  const ref = useRef<HTMLVideoElement | null>(null);
  const [hasLoadedVideo, setIsLoadedVideo] = useState(false);

  useVideoCleanup(ref);
  usePlayVideoInView(ref, hasLoadedVideo && isInView);

  const onCanPlay = useCallback(() => {
    setIsLoadedVideo(true);
  }, []);

  return (
    <S.BackgroundVideo
      ref={ref}
      src={section?.src}
      loop={totalSectionsCount === SINGLE_SECTION}
      muted
      playsInline
      autoPlay
      preload="auto"
      poster={
        !!section?.poster
          ? getOptimizedImageUrl(absoluteAssetUrl(section?.poster), 1920 * 2)
          : undefined
      }
      onCanPlay={onCanPlay}
    />
  );
};
